<template>
  <div
    :data="JSON.stringify(dataInfo())"
    class="itemDetails"
    @click="handleDetails"
  >
    <div
      v-lazy:background-image="item.imgUrl || item.coverSubUrl"
      class="details-imgs"
    >
      <!--        <img :src="item.imgUrl" alt="" class="imgs">-->
      <img
        alt=""
        class="imgs-bofang"
        src="@/assets/images/babyFeeding/spbof.png"
      />
    </div>
    <div class="details-text">
      <div class="text" v-html="item.title"></div>
      <div v-if="item.tag" class="label">
        <van-button
          v-for="tag in setTagItem(item.tag)"
          :key="tag"
          color="#EA872C"
          plain
          >{{ tag }}</van-button
        >
      </div>
      <div class="text-num">
        <p>
          <img alt="" src="@/assets/images/babyFeeding/yanjing.png" />
          <span>{{ item.watchNum }}</span>
        </p>
        <p @click.stop="handleCollect(item)">
          <img
            v-if="item.collectState"
            alt=""
            src="@/assets/images/babyFeeding/shoucang-act.png"
          />
          <img v-else alt="" src="@/assets/images/babyFeeding/shoucang.png" />
          <span>{{ item.collectNum }}</span>
        </p>
        <p @click.stop="handleLink(item)">
          <img
            v-if="item.likeState"
            alt=""
            src="@/assets/images/babyFeeding/dianzan-act.png"
          />
          <img v-else alt="" src="@/assets/images/babyFeeding/dianzan.png" />
          <span>{{ item.likeNum }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BuiedPointClick_Fn,
  Exposurer_babyFeed_Fn,
} from '@assets/js/BuriedPointEvent'
import Api from '@/utils/axiosApi/babyFeedingApi'
import {
  globalGoLogin,
  isUserLogin,
  TestUserAgent,
} from '@/assets/js/common.js'
import { commonAddCollect,commonCancelLike  } from '../../../../utils/commonApiList'

export default {
  name: 'itemDetails',
  props: {
    details: Object,
  },
  data() {
    return {
      item: {},
      babyFeedYue: {},
      crmId: JSON.parse(localStorage.getItem('userInfo'))?.crm_id || '',
      loginFlag: true, // 登录状态，默认true,表示未登录
    }
  },
  watch: {
    details: {
      handler(newVale) {
        this.item = newVale
        Exposurer_babyFeed_Fn.observe('xmhh5_bbsp_view', '.itemDetails', false)
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    Exposurer_babyFeed_Fn.observe('xmhh5_bbsp_view', '.itemDetails', false)
  },
  created() {
    this.loginFlag = isUserLogin()
    this.babyFeedYue = JSON.parse(localStorage.getItem('babyFeedYue')) || {}
  },
  methods: {
    globalGoLogin,
    setTagItem(str) {
      if (str && str != '') {
        const arr = str.split(',')
        return arr.filter((item, index) => index < 3)
      }
      return []
    },
    handleDetails() {
      BuiedPointClick_Fn('xmhh5_bbsp_click', {
        xmhh5_bbsp_title: this.item.oldTitle
          ? this.item.oldTitle
          : this.item.title,
        xmhh5_bbsp_viewstation: this.$route.meta.xmhh5_bbsp_viewstation,
        xmhh5_bbsp_monthage: this.babyFeedYue?.name,
      })
      this.$emit('handleDetails', this.item)
      // sessionStorage.setItem('feedTag', value.tagId)
      // this.$router.push({path: "/babyFeedDetails/" + this.item.id});
      // 自动播放 Android Ios 跳转方式不同
      const { isAndroid } = TestUserAgent()
      setTimeout(() => {
        console.log(isAndroid, 'isAndroid')
        if (this.item.moduleType === '5') {
          if (isAndroid) {
            this.$router.push({
              path: '/foodColumn/foodDetail/' + this.item.id,
            })
          } else {
            location.href = `/foodColumn/foodDetail/${this.item.id}`
          }
        } else {
          if (isAndroid) {
            this.$router.push({ path: '/babyFeedDetails/' + this.item.id })
          } else {
            location.href = `/babyFeedDetails/${this.item.id}`
          }
        }
      }, 200)

      // console.log(this.item, "handleLink");
      // this.initFeedEventAdd(
      //     {
      //       itemId: this.details.id,
      //       crmId: this.crmId,
      //       num: 1,
      //       likeNum: 0,
      //       collectNum: 0,
      //       watchNum: this.details.watchNum + 1,
      //     },
      //     {nums: "watchNum"}
      // );
    },
    dataInfo() {
      return {
        xmhh5_bbsp_title: this.item.oldTitle
          ? this.item.oldTitle
          : this.item.title,
        xmhh5_bbsp_viewstation: this.$route.meta.xmhh5_bbsp_viewstation,
        xmhh5_bbsp_monthage: this.babyFeedYue?.name,
      }
    },
    // 点赞
    handleLink(item) {
      BuiedPointClick_Fn('xmhh5_bbsp_dainzan', {
        xmhh5_bbsp_title: item.oldTitle ? item.oldTitle : item.title,
        xmhh5_bbsp_monthage: this.babyFeedYue?.name,
        xmhh5_bbsp_hudongweizhi:
          this.$route.name != 'babyFeedDetails' ? '其他食谱列表' : '食谱详情页',
      })
      this.$emit('handleLink', item)
      if (this.loginFlag) {
        this.globalGoLogin()
      } else {
        if (item.moduleType == '5') {
          if (item.likeState) {
            this.$http.get(
              '/recipeFoodBanner/cancelLike',
              { crmId: this.crmId, id: item.id },
              (res) => {
                if (res.code == 200) {
                  this.item.likeNum = this.item.likeNum - 1
                  this.item.likeState = !this.item.likeState
                }
              },
              (err)=>{},"lucky"
            )
          } else {
            this.$http.get(
              '/recipeFoodBanner/addLike',
              { crmId: this.crmId, id: item.id },
              (res) => {
                if (res.code == 200) {
                  this.item.likeNum = this.item.likeNum + 1
                  this.item.likeState = !this.item.likeState
                }
                console.log(res)
              },
              (err)=>{},"lucky"
            )
          }
        } else {
          this.initFeedEventAdd(
            {
              itemId: item.id,
              crmId: this.crmId,
              num: item.likeState ? -1 : 1,
              likeNum: item.likeNum,
              collectNum: 0,
              watchNum: 0,
            },
            { nums: 'likeNum', state: 'likeState' }
          )
        }
      }
    },
    // 收藏
    handleCollect(item) {
      BuiedPointClick_Fn('xmhh5_bbsp_shoucang', {
        xmhh5_bbsp_title: item.oldTitle ? item.oldTitle : item.title,
        xmhh5_bbsp_monthage: this.babyFeedYue?.name,
        xmhh5_bbsp_hudongweizhi:
          this.$route.name != 'babyFeedDetails' ? '其他食谱列表' : '食谱详情页',
      })

      this.$emit('handleCollect', item)
      if (this.loginFlag) {
        this.globalGoLogin()
      } else {
        if (item.moduleType == '5') {
          if (!item.collectState) {
            commonAddCollect({ crmId: this.crmId, id: item.id }).then((res) => {
              if (res.code == 200) {
                this.item.collectNum = this.item.collectNum + 1
                this.item.collectState = !this.item.collectState
              }
            })
          } else {
            this.$http.get(
              commonCancelLike({crmId: this.crmId, id: item.id}).then((res)=>{
                if (res.code == 200) {
                  this.item.collectNum = this.item.collectNum - 1
                  this.item.collectState = !this.item.collectState
                }
              })
            )
          }
        } else {
          this.initFeedEventAdd(
            {
              itemId: item.id,
              crmId: this.crmId,
              num: item.collectState ? -1 : 1,
              collectNum: item.collectNum,
              likeNum: 0,
              watchNum: 0,
              tagId: sessionStorage.getItem('feedTag'),
            },
            { nums: 'collectNum', state: 'collectState' }
          )
        }
      }
    },

    initFeedEventAdd(data, key) {
      Api.feedEventAdd(data, (res) => {
        if (res.code == 200) {
          console.error(
            this.item[key.state],
            this.item,
            key.nums,
            this.item[key.nums],
            'this.item[key.nums]'
          )
          // 浏览
          if (key['nums'] == 'watchNum') {
            this.item[key.nums] = this.item[key.nums] + 1
          } else {
            //点赞和收藏
            if (!this.item[key.state]) {
              this.item[key.nums] = this.item[key.nums] + 1
            } else {
              this.item[key.nums] = this.item[key.nums] - 1
            }
            this.item[key.state] = !this.item[key.state]
          }

          this.$emit('handleSuccees', true)
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.itemDetails {
  // margin-left: 8px;
  padding-left: 9px;
  height: 103px;
  display: flex;

  &:last-child {
    .details-text {
      border: none;
    }
  }

  .details-imgs {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 80px;
    margin: auto;
    text-align: center;
    // position: relative;
    border-radius: 4px;
    background-size: 100% 100%;

    .imgs-bofang {
      width: 22px;
      height: 22px;
      // position: absolute;
      // top: 50%;
      // left: 50%;
      // transform: translate(-50%, -50%);
    }
  }

  .details-text {
    width: calc(100% - 96px);
    flex: 1;
    flex-basis: auto;
    padding-left: 16px;
    border-bottom: 1px solid rgba(151, 151, 151, 0.1);

    .text {
      // height: 22px;
      line-height: 18px;
      margin-top: 12px;
      font-size: 16px;
      font-weight: 500;
      color: #333333;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .label {
      overflow: hidden; //溢出内容隐藏
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-top: 7px;

      /deep/ .van-button {
        display: inline-block;
        border-radius: 4px;
        border-color: rgba(250, 222, 91, 0.6) !important;
        font-size: 12px;
        font-weight: 400;
        margin-left: 4px;
        padding: 0 4px;
        height: 22px;

        &:first-child {
          margin-left: 0;
        }
      }
    }

    .text-num {
      display: flex;
      margin-top: 8px;

      p {
        display: flex;
        align-items: center;
        width: 66px;
        height: 16px;

        img {
          margin: 0 4px 1px;
          width: 10px;
        }

        span {
          font-size: 12px;
          color: #999999;
        }

        &:first-child {
          img {
            width: 12px;
          }
        }
      }
    }
  }
}
</style>
